export default "__VITE_ASSET__Bx4yNqrl__"